import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openMultiUpdateOrderModal = asyncModalAdapter({
	upModalName: 'updateOrderMulti',
	openModalName: 'MultiUpdateOrder',
	rejectOnEvent: true
});
